<template>
  <v-container>
    <v-row>
      <Field label="Input date" :value="item.regDt" />
      <Field label="Publisher" :value="item.clsNm" />
      <Field label="Ship Owner" :value="item.owner" />
      <Field label="QM part" :value="item.qmPartNm" />
      <Field label="Issue by" :value="item.issueBy" />
      <Field label="Main event" :value="item.evtNm" />
      <Field label="Reason" :value="item.rsnNm" />
      <Field label="QM Incharger" :value="item.regFull" />
    </v-row>
  </v-container>
</template>

<script>
export default {
  props: {
    item: Object
  },

  components: {
    Field: {
      props: ["label", "value"],
      template: `
        <v-col cols="12" sm="6" md="4" lg="2">
          <v-text-field
            :label="label"
            :value="value"
            dense
            readonly
          />
        </v-col>
      `
    }
  }
}
</script>